import { U as p, a as i, r as R } from "../chunks/index-KrMGGc7j.mjs";
import "../chunks/Linkify-V7PfCeZ8.mjs";
import "escape-html";
import "striptags";
import "vue";
export {
  p as USERID_REGEX,
  i as USERID_REGEX_WITH_SPACE,
  R as default
};
